import {
  Classes,
  Dialog,
  InputGroup,
  NonIdealState,
} from "@blueprintjs/core";
import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { FornecedoresStore } from "../../stores/relatorio/FornecedoresStore";
import {
  MDBBtn,
  MDBCol,
  MDBModalBody,
  MDBRow,
} from "mdbreact";
import { IEmpresa } from "../../model";
import * as utils from "../../utils";
import {
  BootstrapTable,
  SearchField,
  TableHeaderColumn,
} from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { observable } from "mobx";
import LoadingModal from "../loading/LoadingModal";

var debounce = require('lodash.debounce');

interface ClientesPageState {
  date1: string;
  date2: string;
  date: any;
}

@observer
export default class ClientesPage extends React.Component<any, ClientesPageState> {

  obs = observable({
    fetchOptions: {} as any
  });

  constructor(props: {}) {
    super(props);
    AppStore.setTitle("Clientes");

    this.obs.fetchOptions = debounce(this.handleSearch.bind(this), 800);

  }

  async componentDidMount() {

    await FornecedoresStore.loadClientes(1, FornecedoresStore.obs.filter);

  }

  handleSearch = async () => {

    await FornecedoresStore.loadClientes(1, FornecedoresStore.obs.filter);

  };

  handlePageChange = async (page: number) => {

    await FornecedoresStore.loadClientes(page, FornecedoresStore.obs.filter);

  };

  loadClientesFilter = (e) => {

    FornecedoresStore.obs.filter = e
    FornecedoresStore.obs.currentPage = 1

    this.obs.fetchOptions()

  };

  refresh = () => {
    window.location.reload();
  };

  handleEdit(empresa: IEmpresa) {
    AppStore.setLocation(`/empresa/edit/${empresa.cipher_id}`);
  }

  onSelectAll = (isSelected) => {
    if (isSelected) {
      return [];
    } else {
      return [];
    }
  };

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Razão Social, CNPJ)"
      />
    );
  };

  renderData() {
    let items = FornecedoresStore.obs.clientes?.map(cnpj => {
      return (
        {
          cipher_id: cnpj.id,
          identificador: cnpj.sped_id,
          id: cnpj.nome,
          name: utils.formatCnpj(cnpj.cnpj),
          endereco: cnpj.logradouro + ", " + cnpj.uf + " | CEP: " + cnpj.cep,
        }
      );
    });

    function handleView(row) {
      FornecedoresStore.viewClienteReq(row);
      FornecedoresStore.obs.viewFornecedor = true;
    }

    function buttonFormatter(cell, row) {
      return (
        <MDBBtn
          color="default"
          rounded
          size="sm"
          onClick={(e) => handleView(row)}
        >
          <img src="/images/view.png" width="18px" />
        </MDBBtn>
      );
    }

    let ativiPrin = FornecedoresStore.obs.atividadesPrincipais?.map(ativ => {
      return <p key={ativ}>{ativ}</p>;
    });

    let ativiSec = FornecedoresStore.obs.atividadesSecundarias?.map(ativs => {
      return <p key={ativs}>{ativs}</p>;
    });

    return (
      <div className="empresas-page">
        <LoadingModal open={FornecedoresStore.obs.waitFornecedores} onClose={() => FornecedoresStore.obs.waitFornecedores = false} title={"Buscando clientes"} />
        <Dialog
          isOpen={FornecedoresStore.obs.viewFornecedor}
          onClose={(e) => FornecedoresStore.obs.viewFornecedor = false}
          title="Dados do Cliente"
          className="dados-soli"
        >
          <MDBModalBody style={{ height: 500, overflow: 'auto' }}>
            <div className={Classes.DIALOG_BODY}>
              <div style={{ marginBottom: 10, fontSize: 10 }}>
                <MDBRow>
                  {FornecedoresStore.obs.Cliente &&
                    (
                      <>
                        <MDBCol md="7">
                          <p>
                            <b>Razão Social:</b>{" "}
                            {FornecedoresStore.obs.Cliente.nome}
                          </p>
                          <p>
                            <b>Nome Fantasia:</b>{" "}
                            {FornecedoresStore.obs.Cliente.fantasia}
                          </p>
                          <p>
                            <b>CNPJ:</b> {FornecedoresStore.obs.Cliente.cnpj}
                          </p>
                          <p>
                            <b>Logradouro:</b>{" "}
                            {FornecedoresStore.obs.Cliente.logradouro}{" "}
                            {FornecedoresStore.obs.Cliente.complemento},{" "}
                            {FornecedoresStore.obs.Cliente.numero}
                          </p>
                          <p>
                            <b>Bairro:</b> {FornecedoresStore.obs.Cliente.bairro}
                            {" "}
                            ({FornecedoresStore.obs.Cliente.cep})
                          </p>
                          <p>
                            <b>Cidade / Estado:</b>{" "}
                            {FornecedoresStore.obs.Cliente.municipio},{" "}
                            {FornecedoresStore.obs.Cliente.uf}
                          </p>
                        </MDBCol>
                        <MDBCol md="5">
                          <p>
                            <b>Natureza Jurídica:</b>{" "}
                            {FornecedoresStore.obs.Cliente.natureza_juridica}
                          </p>
                          <p>
                            <b>Porte:</b> {FornecedoresStore.obs.Cliente.porte}
                          </p>
                          <p>
                            <b>Tipo:</b> {FornecedoresStore.obs.Cliente.tipo}
                          </p>
                          <p>
                            <b>Situação:</b>{" "}
                            {FornecedoresStore.obs.Cliente.situacao}
                          </p>
                          <p>
                            <b>Data Abertura:</b>{" "}
                            {FornecedoresStore.obs.Cliente.abertura}
                          </p>
                          <p>
                            <b>Data última situação:</b>{" "}
                            {FornecedoresStore.obs.Cliente.data_situacao}
                          </p>
                          <p>
                            <b>Contatos:</b>{" "}
                            {FornecedoresStore.obs.Cliente.telefone} -{" "}
                            {FornecedoresStore.obs.Cliente.email}
                          </p>
                        </MDBCol>
                        <MDBCol md="12">
                          <h3 className="titleProccess titleCnae">
                            CNAE Principal
                          </h3>
                          {ativiPrin}
                        </MDBCol>
                        <MDBCol md="12">
                          <h3 className="titleProccess titleCnae">
                            CNAEs Secundários
                          </h3>
                          {ativiSec}
                        </MDBCol>
                      </>
                    )}
                </MDBRow>
              </div>
            </div>
          </MDBModalBody>
        </Dialog>

        <MDBRow>
          <MDBCol md="6" className="inputFilter">
            <InputGroup
              round
              leftIcon="search"
              style={{ width: 600, borderRadius: "10px" }}
              placeholder="Filtrar (Razão Social, CNPJ)"
              value={FornecedoresStore.obs.filter}
              onChange={(e: any) => this.loadClientesFilter(e.target.value)}
            />
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol md="12" sm="12" xs="12">
            <BootstrapTable
              className="TableDefault"
              ref="table"
              data={items}
            >
              <TableHeaderColumn dataField="cipher_id" isKey={true} hidden>
                #
              </TableHeaderColumn>
              <TableHeaderColumn dataField="identificador" width={"15%"}>
                ID
              </TableHeaderColumn>
              <TableHeaderColumn dataField="id" width={"40%"}>
                Razão Social
              </TableHeaderColumn>
              <TableHeaderColumn dataField="name" width={"15%"}>
                CNPJ
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="endereco"
                width={"35%"}
              >
                Endereço
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={buttonFormatter} width={"10%"}>
                Detalhes
              </TableHeaderColumn>
            </BootstrapTable>
          </MDBCol>
        </MDBRow>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={FornecedoresStore.obs.currentPage}
            totalCount={FornecedoresStore.obs.clientes_length}
            pageSize={20}
            onPageChange={page => this.handlePageChange(FornecedoresStore.obs.currentPage = page)}
          />
        </div>
      </div>
    );
  }

  renderNonIdeal() {
    return (
      <div className="nz-non-ideal">
        <NonIdealState
          icon="box"
          title="Você não possui permissão para acessar essa página"
        />
      </div>
    );
  }

  renderNormal() {
    let userPermissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.permissao : "";
    return (
      <>
        {this.renderData()}
      </>
    );
  }

  render() {
    let niveis_acesso = AppStore.obs1.usuario
      ? AppStore.obs1.usuario.niveis_acesso
      : [""];
    if (niveis_acesso.indexOf("l1") == -1) {
      return this.renderNonIdeal();
    } else {
      return this.renderNormal();
    }
  }
}
